import { X, NotebookPen } from 'lucide-react';
import type { WeeklyDigest } from '@/hooks/useWeeklyDigest';

interface WeeklyReflectionDigestProps {
  digest: WeeklyDigest;
  onDismiss: () => void;
}

export const WeeklyReflectionDigest = ({
  digest,
  onDismiss,
}: WeeklyReflectionDigestProps) => {
  return (
    <div className="relative p-4 rounded-xl bg-muted/30 border border-border/50">
      <button
        onClick={onDismiss}
        className="absolute top-3 right-3 p-1 rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
        aria-label="Dismiss weekly digest"
      >
        <X className="w-4 h-4" />
      </button>

      <div className="flex items-center gap-2 mb-3">
        <NotebookPen className="w-4 h-4 text-primary" />
        <span className="text-sm font-medium">Weekly Reflection Digest</span>
      </div>

      <div className="space-y-2">
        <p className="text-sm text-muted-foreground">
          You reflected <span className="text-foreground font-medium">{digest.daysReflected} of 7</span> days this week.
        </p>

        <div className="flex flex-wrap gap-x-4 gap-y-1 text-sm">
          {digest.topExpressed && (
            <span className="text-muted-foreground">
              Top expressed:{' '}
              <span className="text-emerald-600 dark:text-emerald-400 font-medium">
                {digest.topExpressed.name}
              </span>
              <span className="text-muted-foreground/70"> ({digest.topExpressed.count}x)</span>
            </span>
          )}
          {digest.topSuppressed && (
            <span className="text-muted-foreground">
              Top suppressed:{' '}
              <span className="text-orange-600 dark:text-orange-400 font-medium">
                {digest.topSuppressed.name}
              </span>
              <span className="text-muted-foreground/70"> ({digest.topSuppressed.count}x)</span>
            </span>
          )}
        </div>

        {digest.insight && (
          <p className="text-sm italic text-muted-foreground pt-1">
            {digest.insight}
          </p>
        )}
      </div>
    </div>
  );
};
